import { Data } from '../model/rule-engine.model';

/**
 * Returns a function receiving data and returning given attribute of given data
 * @example
 * // given
 * const data = [{foo:'bar', baz:1 }, {foo:'bazbaz', baz:5 }]
 * // when
 * const bazValues = data.map(pick('baz'))
 * const fooValues = data.map(pick('foo'))
 * // then
 * bazValues // [1,5]
 * fooValues // ['bar','bazbaz']
 * @param attr
 * @returns
 */
export const pick = (attr: string) => (data: Data) => data[attr];
